import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, CircularProgress, IconButton, Tooltip, Typography } from '@mui/material';
import { KrCard } from '../../card/KrCard';

const Message = ({ children }) => (
  <Typography variant="body2" color="text.secondary">
    {children}
  </Typography>
);

/** KrCard plus the loading, error and empty states every widget needs. */
export const WidgetCard = ({ title, status = 'READY', emptyText = 'No data', onRefresh, children }) => (
  <KrCard
    title={title}
    minHeight={480}
    buttons={
      onRefresh && (
        <Tooltip title="Refresh">
          <IconButton size="small" onClick={onRefresh}>
            <FontAwesomeIcon icon={fas.faRotateRight} size="xs" />
          </IconButton>
        </Tooltip>
      )
    }
  >
    {status === 'READY' ?
      children
    : <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        {status === 'LOADING' && <CircularProgress size={32} />}
        {status === 'ERROR' && <Message>Could not load data</Message>}
        {status === 'EMPTY' && <Message>{emptyText}</Message>}
      </Box>
    }
  </KrCard>
);
